import React from 'react';
import { ClassAssembly5D2026 } from '../views';

const ClassAssemblyPage = () => {
    return <ClassAssembly5D2026 />;
  };
  
  export default ClassAssemblyPage;